import { vars } from 'src/core/themes';
import styled from 'styled-components/macro';

export const VendorTableContainer = styled.div`
  border: 1px solid ${(props) => props.theme.colors.borderPrimary};
  border-radius: ${() => vars.spacing.sm};
  overflow: hidden;
`;
